export enum ActorLoaderKey {
  USER_SAVE = 'user-save',
}
